import { WrapperProps } from '../..'

interface TabPanelProps extends WrapperProps {
  index: number
  prefix: string
  selectedTab: number
}

export const TabPanel = ({
  children,
  index,
  prefix,
  selectedTab
}: TabPanelProps) => {
  const isTabSelected = selectedTab === index

  return (
    <div
      role="tabpanel"
      hidden={!isTabSelected}
      id={`${prefix}-tabpanel-${index}`}
      aria-labelledby={`${prefix}-tab-${index}`}
    >
      {isTabSelected && <>{children}</>}
    </div>
  )
}
